<div style="margin-top: 20px">
  @if (startanimation) {
    <div style="display: flex; width: 100%; height: 600px">
      <div
        style="
          flex: 2;
          display: flex;
          flex-direction: column;
          margin: 5px;
          margin-left: 0px;
          margin-right: 0px;
          position: relative;
        "
        class="group-container">
        @if (contentEdit) {
          <div class="group-action-button-container">
            <coin-v2-button
              type="primary"
              icon="add"
              text="Add"
              (click)="add(['left'])"></coin-v2-button>
          </div>
        }
        @for (item of item.collection.left; track item; let i = $index) {
          <div
            class="compilation-image"
            style="margin: 5px; margin-left: 0px; flex: 1">
            @if (contentEdit) {
              <coin-v2-button
                type="secondary"
                svgIcon="edit"
                class="edit-picture-button"
                [text]="'cms.content-pages.change-image-button' | translate"
                (click)="editPicture($any(item))"></coin-v2-button>
            }
            <div
              animate.enter="expand"
              animate.leave="shrink"
              class="sub-img"
              [ngStyle]="{
                background: 'url(' + item.img + ')',
                'background-size': 'cover',
                'background-repeat': 'no-repeat',
                width: '100%',
                height: '100%'
              }"></div>
            @if (!contentEdit) {
              <h3
                animate.enter="expand"
                animate.leave="shrink">
                <span>{{ item.text }}</span>
              </h3>
            }
            @if (contentEdit) {
              <h3>
                <span
                  #spanElement
                  style="cursor: text"
                  [contentEditable]="contentEdit"
                  [textContent]="item.text"
                  (input)="item.text = spanElement.textContent"></span>
              </h3>
            }
            @if (contentEdit) {
              <div class="action-button-container">
                <coin-v2-button
                  type="secondary"
                  icon="close"
                  text="Remove"
                  (click)="remove(['left'], i)"></coin-v2-button>
              </div>
            }
          </div>
        }
      </div>
      <div style="flex: 3; display: flex; flex-direction: column; margin-left: 5px">
        <div
          class="basic-container group-container"
          style="flex-direction: row; margin: 5px 0px; margin-right: 0px; margin-bottom: 0px; position: relative">
          @if (contentEdit) {
            <div
              class="group-action-button-container"
              style="right: 10px">
              <coin-icon-button
                type="primary"
                icon="add"
                (click)="add(['right', 'top'])"></coin-icon-button>
            </div>
          }
          @for (item of item.collection.right.top; track item; let i = $index) {
            <div
              class="compilation-image"
              style="margin: 5px">
              @if (contentEdit) {
                <coin-v2-button
                  type="secondary"
                  svgIcon="edit"
                  class="edit-picture-button"
                  [text]="'cms.content-pages.change-image-button' | translate"
                  (click)="editPicture($any(item))"></coin-v2-button>
              }
              <div
                animate.enter="expand"
                animate.leave="shrink"
                class="sub-img"
                [ngStyle]="{
                  background: 'url(' + item.img + ')',
                  'background-size': 'cover',
                  'background-repeat': 'no-repeat',
                  width: '100%',
                  height: '100%'
                }"></div>
              @if (!contentEdit) {
                <h3
                  animate.enter="expand"
                  animate.leave="shrink">
                  <span>{{ item.text }}</span>
                </h3>
              }
              @if (contentEdit) {
                <h3>
                  <span
                    #spanElement
                    style="cursor: text"
                    [contentEditable]="contentEdit"
                    [textContent]="item.text"
                    (input)="item.text = spanElement.textContent"></span>
                </h3>
              }
              @if (contentEdit) {
                <div class="action-button-container">
                  <coin-icon-button
                    type="secondary"
                    icon="close"
                    (click)="remove(['right', 'top'], i)"></coin-icon-button>
                </div>
              }
            </div>
          }
        </div>
        <div class="bottom-right">
          <div
            class="basic-container with-margin group-container"
            style="flex-direction: column; margin-left: 0px; margin-right: 5px">
            @if (contentEdit) {
              <div
                class="group-action-button-container"
                style="right: 0px">
                <coin-icon-button
                  type="primary"
                  icon="add"
                  (click)="add(['right', 'bottom', 'left'])"></coin-icon-button>
              </div>
            }
            @for (item of item.collection.right.bottom.left; track item; let i = $index) {
              <div
                class="compilation-image"
                style="margin: 5px; flex: 1">
                @if (contentEdit) {
                  <coin-v2-button
                    type="secondary"
                    svgIcon="edit"
                    class="edit-picture-button"
                    [text]="'cms.content-pages.change-image-button' | translate"
                    (click)="editPicture($any(item))"></coin-v2-button>
                }
                <div
                  animate.enter="expand"
                  animate.leave="shrink"
                  class="sub-img"
                  [ngStyle]="{
                    background: 'url(' + item.img + ')',
                    'background-size': 'cover',
                    'background-repeat': 'no-repeat',
                    width: '100%',
                    height: '100%'
                  }"></div>
                @if (!contentEdit) {
                  <h3
                    animate.enter="expand"
                    animate.leave="shrink">
                    <span>{{ item.text }}</span>
                  </h3>
                }
                @if (contentEdit) {
                  <h3>
                    <span
                      #spanElement
                      style="cursor: text"
                      [contentEditable]="contentEdit"
                      [textContent]="item.text"
                      (input)="item.text = spanElement.textContent"></span>
                  </h3>
                }
                @if (contentEdit) {
                  <div class="action-button-container">
                    <coin-icon-button
                      type="secondary"
                      icon="close"
                      (click)="remove(['right', 'bottom', 'left'], i)"></coin-icon-button>
                  </div>
                }
              </div>
            }
          </div>
          <div
            class="basic-container with-margin group-container"
            style="flex-direction: column">
            @if (contentEdit) {
              <div
                class="group-action-button-container"
                style="right: 0px">
                <coin-icon-button
                  type="primary"
                  icon="add"
                  (click)="add(['right', 'bottom', 'right'])"></coin-icon-button>
              </div>
            }
            @for (item of item.collection.right.bottom.right; track item; let i = $index) {
              <div
                class="compilation-image"
                style="margin: 5px; flex: 1">
                @if (contentEdit) {
                  <coin-v2-button
                    type="secondary"
                    svgIcon="edit"
                    class="edit-picture-button"
                    [text]="'cms.content-pages.change-image-button' | translate"
                    (click)="editPicture($any(item))"></coin-v2-button>
                }
                <div
                  animate.enter="expand"
                  animate.leave="shrink"
                  class="sub-img"
                  [ngStyle]="{
                    background: 'url(' + item.img + ')',
                    'background-size': 'cover',
                    'background-repeat': 'no-repeat',
                    width: '100%',
                    height: '100%'
                  }"></div>
                @if (!contentEdit) {
                  <h3
                    animate.enter="expand"
                    animate.leave="shrink">
                    <span>{{ item.text }}</span>
                  </h3>
                }
                @if (contentEdit) {
                  <h3>
                    <span
                      #spanElement
                      style="cursor: text"
                      [contentEditable]="contentEdit"
                      [textContent]="item.text"
                      (input)="item.text = spanElement.textContent"></span>
                  </h3>
                }
                @if (contentEdit) {
                  <div class="action-button-container">
                    <coin-icon-button
                      type="secondary"
                      icon="close"
                      (click)="remove(['right', 'bottom', 'right'], i)"></coin-icon-button>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
